import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-prod-grp2',
  templateUrl: './prod-grp2.component.html',
  styleUrls: ['./prod-grp2.component.css']
})
export class ProdGrp2Component implements OnInit {
    prodGrpId;

    prodGrp2Id;

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.prodGrpId = this.stateService.getStateParams()['prodgrp_id'];
        this.prodGrp2Id = this.stateService.getStateParams()['prodgrp2_id'];
    }

    private async loadEdit() {
        if (!!this.prodGrpId && !!this.prodGrp2Id) {
            this.edit = (await this.datatask.Post(3070, {
                prodgrp_id: this.prodGrpId,
                prodgrp2_id: this.prodGrp2Id
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3071, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(3073, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back(2);
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    prodgrp_id: number;
    prodgrp_name: string;
    prodgrp2_id: number;
    prodgrp2_name: string;
    isnew: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrp2', {
//        templateUrl: 'views/components/views/prodGrp2/prodGrp2.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'prodGrp2Service', function ($stateParams, stateService, modalService, translateService, prodGrp2Service) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrpId = $stateParams.prodgrp_id;
//            let prodGrp2Id = $stateParams.prodgrp2_id;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await prodGrp2Service.getEdit({
//                    prodgrp_id: prodGrpId,
//                    prodgrp2_id: prodGrp2Id
//                }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                prodGrp2Service.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    prodGrp2Service.deleteItem(vm.model.edit).then(function (response) {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back(2);
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
